import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C930.545,0 906.667,23.8782 906.667,53.3333 L906.667,217.758 C755.322,243.149 640,374.774 640,533.333 C640,568.903 645.803,603.117 656.515,635.081 L142.857,1524.76 C63.9596,1661.42 110.781,1836.16 247.436,1915.06 C263.835,1924.52 284.804,1918.9 294.271,1902.51 L592.091,1386.67 L906.667,1386.67 L906.667,1493.33 C906.667,1522.79 930.545,1546.67 960,1546.67 C989.455,1546.67 1013.33,1522.79 1013.33,1493.33 L1013.33,1386.67 L1327.7,1386.67 L1625.52,1902.51 C1634.99,1918.9 1655.96,1924.52 1672.36,1915.06 C1809.01,1836.16 1855.84,1661.42 1776.94,1524.76 L1263.41,635.306 C1274.17,603.278 1280,568.987 1280,533.333 C1280,374.774 1164.68,243.149 1013.33,217.758 L1013.33,53.3333 C1013.33,23.8781 989.455,0 960,0 Z M1266.12,1280 L1016.87,848.294 C998.417,851.605 979.41,853.333 960,853.333 C940.525,853.333 921.456,851.594 902.94,848.261 L653.675,1280 L906.667,1280 L906.667,1173.33 C906.667,1143.88 930.545,1120 960,1120 C989.455,1120 1013.33,1143.88 1013.33,1173.33 L1013.33,1280 L1266.12,1280 Z M960,714.667 C1060.15,714.667 1141.33,633.481 1141.33,533.333 C1141.33,433.186 1060.15,352 960,352 C859.852,352 778.667,433.186 778.667,533.333 C778.667,633.481 859.852,714.667 960,714.667 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCompassSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCompassSolid, _Component);

  var _super = _createSuper(IconCompassSolid);

  function IconCompassSolid() {
    _classCallCheck(this, IconCompassSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCompassSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCompass",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCompassSolid.displayName = "IconCompassSolid";
  return IconCompassSolid;
}(Component);

IconCompassSolid.glyphName = 'compass';
IconCompassSolid.variant = 'Solid';
IconCompassSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCompassSolid;
export { IconCompassSolid };